import { createRouter, createWebHashHistory } from 'vue-router';
import LoginPage from '@/views/LoginPage.vue';
import { useAuth } from '@/store/auth';
import Dashboard from '@/views/Dashboard.vue';

const routes = [
  {
    path: '/',
    name: 'Dashboard',
    component: () => import('../views/Dashboard.vue'),
    meta: { requiresAuth: true }
  },
  //{
  //  path: '/',
  //  redirect: (to) => {
  //    const isAuthenticated = JSON.parse(localStorage.getItem("isAuthenticated"));
  //    return isAuthenticated ? '/home' : '/login';
  //  }
  //},
  //{
  //  path: '/home',
  //  name: 'Home',
  //  component: Dashboard,
  //  meta: { requiresAuth: true }
  //},
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
  },
  {
    path: '/v2',
    name: 'version2',
    component: () => import('../views/Dashboard.vue'),
    meta: { requiresAuth: true }
  },
];

const router = createRouter({
  history: createWebHashHistory('/'),
  routes,
});

router.beforeEach((to, from, next) => {
  const isAuthenticated = JSON.parse(localStorage.getItem("isAuthenticated"));
  console.log("beforeEach: " + isAuthenticated);
  if (to.meta.requiresAuth && !isAuthenticated) {
    next('/login'); // Stuur niet-ingelogde gebruikers naar de loginpagina
  } 
  else {
    next();
  }
});

export default router;
